import React from 'react';

import forms from '../data';
import Card from '../components/Card';

function AllForms() {

    //alphabetize the list of forms
    const sorted = forms.sort((a, b) => (a.title > b.title) ? 1 : -1)

    return (
        <div id="form-card-container">
            {sorted.map((form) => (
                <Card
                    key={form.id}
                    formLink={`/form/${form.id}`}
                    formLabel={form.label}
                    bgColor={form.color}
                    formTitle={form.title}
                />
            ))}
        </div>
    );
}

export default AllForms;